import { render, staticRenderFns } from "./Purchase-Order.vue?vue&type=template&id=60bb454b"
import script from "./Purchase-Order.vue?vue&type=script&lang=js"
export * from "./Purchase-Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports